import { render, staticRenderFns } from "./SingleExtCollection.vue?vue&type=template&id=163aa47b&scoped=true&"
import script from "./SingleExtCollection.vue?vue&type=script&lang=js&"
export * from "./SingleExtCollection.vue?vue&type=script&lang=js&"
import style0 from "./SingleExtCollection.vue?vue&type=style&index=0&id=163aa47b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aa47b",
  null
  
)

export default component.exports